import $ from 'jquery';
import langFromUrl from 'lib/util/langFromUrl';
import tdaConfig from 'lib/util/tda.config';
import zip from 'lib/util/zip';
import PageCache from 'lib/page-cache';
import offersServiceFactory from 'lib/services/offers-service';
import queryStringToObj from 'lib/queryStringObj';

var offersService = offersServiceFactory(tdaConfig.offers.r2_api_key);

function __convertToArray(variable) {
  if (variable) {
    if (Array.isArray(variable)) {
      return variable;
    }
    if (variable.split(',').length > 1) {
      return variable.split(',');
    }
    return [variable];
  }
  return [];
}

var offerAjaxFiltered = {
  getOffers: function (request) {
    var self = this;
    return new Promise(function (resolve) {
      if (request && typeof request !== 'object') {
        var idx = request.indexOf('?');
        if (idx >= 0) request = request.substring(idx + 1);
        request = queryStringToObj(request);
      } else request = request || {};

      var defRequest = {
        tdaCode: tdaConfig.tda.code,
        zipCode: zip.getCookiedDefaultFallback(),
        lang: langFromUrl(),
        // pageSize: self.pageSize
      };

      var realRequest = $.extend({}, defRequest);
      request = $.extend(defRequest, request);
      var cacheId = 'offer.ajax.filtered.' + request.zipCode + '.' + request.lang;
      realRequest.startIndex = 0;
      realRequest.pageSize = 1000;
      realRequest.lang = request.lang;
      realRequest.tdaCode = request.tdaCode;
      realRequest.zipCode = request.zipCode;
      realRequest.effectiveDate = request.effectiveDate; // BAT-5583
      realRequest.year = request.year;

      if (request.excludeSeries) {
        realRequest.excludeSeries = request.excludeSeries;
      }
      if (!PageCache.hasOrPending(cacheId)) {
        PageCache.maybeSet(cacheId, offersService.offers().all(realRequest));
      }

      PageCache.await(cacheId)
        .then(function offerStripRes(res) {
          if (!res.containsOffers) {
            resolve(res); // self.throwErrors(res.error);
          }
          resolve(self.filterOffers(res, request));
        })
        .catch(function (err) {
          self.throwErrors(err);
        });
    });
  },

  filterOffers: function (res, request) {
    var self = this;
    var rv = $.extend({}, res);
    if (rv.offerBundle && rv.offerBundle.offers.length) {
      rv.offerBundle = { offers: [] };
      var offerList = $.extend([], res.offerBundle.offers);
      var filteredOfferList = [];
      var resultList = [];
      var typeFilterActive = false;
      var seriesFilterActive = false;
      var modelFilterActive = false;
      var labelFilterActive = false;
      var fixOfferTypes = ['apr', 'cash', 'lease', 'msrp', 'multiple_vehicle'];


      // filters
      var offerTypeF = __convertToArray(request.offerType);
      var seriesF = __convertToArray(request.series);
      var modelF = __convertToArray(request.model);
      var labelF = __convertToArray(request.offerLabels);

      for (var j0 = 0; j0 < offerList.length; j0 += 1) {
        var ofr = offerList[j0];
        ofr.isTypeFiltered = false;
        ofr.isSeriesFiltered = false;
        ofr.isModelFiltered = false;
        ofr.isLabelFiltered = false;
        // BAT-5020 change offer type for GST TFS Cash and Bonus Cash to Bonus
        var tfsLabel = request.lang === 'es' ? 'en efectivo tfs' : 'tfs cash';
        var bonusLabel = request.lang === 'es' ? 'en bono' : 'bonus';
        if (request.tdaCode === 'GST10' && ofr.offerType.toLowerCase() === 'cash'
            && ofr.cash && ofr.cash.subTypeLabels
            && (ofr.cash.subTypeLabels.toLowerCase() === tfsLabel
            || ofr.cash.subTypeLabels.toLowerCase() === bonusLabel)) {
          ofr.offerType = 'bonus';
          ofr.bonus = true;
        }
      }
      for (var iofr = 0; iofr < offerTypeF.length; iofr += 1) {
        typeFilterActive = true;
        for (var jofr = 0; jofr < offerList.length; jofr += 1) {
          if (offerList[jofr].offerType && offerTypeF[iofr]
              && offerTypeF[iofr].toLowerCase() === offerList[jofr].offerType.toLowerCase()) {
            offerList[jofr].isTypeFiltered = true;
          } else if (offerTypeF[iofr] === 'misc' && !(fixOfferTypes.indexOf(offerList[jofr].offerType.toLowerCase()) >= 0)) {
            offerList[jofr].isTypeFiltered = true;
          } else if (offerTypeF[iofr] === 'cash' && offerList[jofr].offerType.toLowerCase() === 'multiple_vehicle') {
            offerList[jofr].isTypeFiltered = true;
          }
        }
      }
      for (var iser = 0; iser < seriesF.length; iser += 1) {
        seriesFilterActive = true;
        for (var jser = 0; jser < offerList.length; jser += 1) {
          var offer = offerList[jser];
          var serie = offer.seriesList && offer.seriesList.series ? offer.seriesList.series.id : null;
          if (serie && seriesF[iser] && seriesF[iser].toLowerCase() === serie.toLowerCase()) {
            offerList[jser].isSeriesFiltered = true;
          } else if (seriesF[iser] && (offer.offerType.toLowerCase() === 'multiple_vehicle' || offer.offerType.toLowerCase() === 'miscellaneous') && offer.seriesList
              && offer.seriesList.series && offer.seriesList.series.length > 0 ) {
            for (var kser = 0; kser < offer.seriesList.series.length; kser += 1) {
              var id = offer.seriesList.series[kser].id;
              id = id ? (',' + id.replace(/ /g, '') + ',') : '';
              if (id.indexOf(',' + seriesF[iser].toLowerCase() + ',') >= 0) {
                offerList[jser].isSeriesFiltered = true;
                break;
              }
            }
          }
        }
      }
      if (modelF && modelF.length > 0) {
        modelFilterActive = true;
        for (var jmod = 0; jmod < offerList.length; jmod += 1) {
          var offerM = offerList[jmod];
          var modelIncluded = offerM.seriesList && offerM.seriesList.series ? offerM.seriesList.series.included : null;
          if (modelIncluded) {
            modelIncluded = modelIncluded ? (',' + modelIncluded.replace(/ /g, '') + ',') : '';
            var modelExcluded = offerM.seriesList.series.excluded;
            modelExcluded = modelExcluded ? (',' + modelExcluded.replace(/ /g, '') + ',') : '';
            for (var imod = 0; imod < modelF.length; imod += 1) {
              if (modelIncluded.indexOf(',' + modelF[imod].toLowerCase() + ',') >= 0) {
                offerList[jmod].isModelFiltered = true;
                break;
              }
            }
            for (var emod = 0; emod < modelF.length; emod += 1) {
              if (modelExcluded && modelExcluded.indexOf(',' + modelF[emod].toLowerCase() + ',') >= 0) {
                offerList[jmod].isModelFiltered = false;
                break;
              }
            }
          }
        }
      }
      for (var ilbl = 0; ilbl < labelF.length; ilbl += 1) {
        labelFilterActive = true;
        for (var jlbl = 0; jlbl < offerList.length; jlbl += 1) {
          if (offerList[jlbl].offerLabelNum && labelF[ilbl]
              && labelF[ilbl] == offerList[jlbl].offerLabelNum) {
            offerList[jlbl].isLabelFiltered = true;
          }
        }
      }
      for (var j1 = 0; j1 < offerList.length; j1 += 1) {
        if ((offerList[j1].isTypeFiltered === true || typeFilterActive === false)
            && (offerList[j1].isSeriesFiltered === true || seriesFilterActive === false)
            && (offerList[j1].isModelFiltered === true || modelFilterActive === false)
            && (offerList[j1].isLabelFiltered === true || labelFilterActive === false)) {
          filteredOfferList.push(offerList[j1]);
        }
      }
      var pageSizeP = request.pageSize || filteredOfferList.length;
      var startIndexP = request.startIndex || 0;
      var startP = (1 * startIndexP); // * pageSizeP;
      if (startP > filteredOfferList.length) startP = filteredOfferList.length;
      var endP = 1 * startIndexP + 1 * pageSizeP; // (1 * startIndexP + 1) * pageSizeP;
      if (endP > filteredOfferList.length) endP = filteredOfferList.length;

      for (var i1 = startP; i1 < endP; i1 += 1) {
        resultList.push(filteredOfferList[i1]);
      }
      rv.offerBundle.offers = resultList;
      rv.totalOffers = filteredOfferList.length;
    }


    return rv;
  },

  throwErrors: function throwErr(err) {
    if (err && err[0] === 'Mismatch zip and tda code entered.') {
      throw new Error('zip_mismatch');
    }
    throw new Error('no_offers');
  },

  handleErrors: function handleErr(err) {
    console.error('err: ', err.name, err.message); // eslint-disable-line no-console
  },
};

export default offerAjaxFiltered;
